import React from "react";
import {
  Autocomplete,
  Button,
  Stack,
  TextField,
} from "@mui/material";

/**
 * Shared filter panel: Shop Name and Shop Location autocomplete (unique options)
 * plus From/To date range and Clear. Used in Coupon Progress Report and My Visitors.
 */
export default function ClaimsFilterPanel({
  shopNames = [],
  shopLocations = [],
  shopName,
  shopLocation,
  dateFrom,
  dateTo,
  onShopNameChange,
  onShopLocationChange,
  onDateFromChange,
  onDateToChange,
  onClear,
  size = "small",
  minWidth = 180,
}) {
  const uniqueShopNames = [...new Set(shopNames)].filter(Boolean).sort();
  const uniqueShopLocations = [...new Set(shopLocations)].filter(Boolean).sort();

  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      spacing={2}
      alignItems="center"
      flexWrap="wrap"
      useFlexGap
      sx={{ mb: 2 }}
    >
      <Autocomplete
        size={size}
        options={uniqueShopNames}
        value={shopName || null}
        onChange={(_, v) => onShopNameChange(v || "")}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Shop Name"
            placeholder="Select shop name"
          />
        )}
        sx={{ minWidth }}
      />
      <Autocomplete
        size={size}
        options={uniqueShopLocations}
        value={shopLocation || null}
        onChange={(_, v) => onShopLocationChange(v || "")}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Shop Location"
            placeholder="Select location"
          />
        )}
        sx={{ minWidth }}
      />
      <TextField
        size={size}
        label="From date"
        type="date"
        value={dateFrom}
        onChange={(e) => onDateFromChange(e.target.value)}
        InputLabelProps={{ shrink: true }}
        sx={{ minWidth: 160 }}
      />
      <TextField
        size={size}
        label="To date"
        type="date"
        value={dateTo}
        onChange={(e) => onDateToChange(e.target.value)}
        InputLabelProps={{ shrink: true }}
        sx={{ minWidth: 160 }}
      />
      <Button size={size} variant="outlined" onClick={onClear}>
        Clear filters
      </Button>
    </Stack>
  );
}
